<template>
    <div class="bottom">
        <div class="max-w-screen-md mx-auto h-full flex flex-col items-center justify-center px-4">
            <div class="flex-1 grid items-center justify-center">
                <AnimatedElement animation="animate__fadeInUp">
                    <FlowerIcon name="flower" fill="white" class="w-32 h-32" />
                </AnimatedElement>
            </div>
            <div class="my-6">
                <p class="text-white">© 2025 Flower Shop. All Rights Reserved.</p>
            </div>
        </div>
    </div>
</template>

<script>
import AnimatedElement from "./AnimatedElement.vue";
import FlowerIcon from "./FlowerIcon.vue";

export default {
    components: {
        AnimatedElement,
        FlowerIcon,
    },
};
</script>

<style>
.bottom {
    height: 100vh;
    background-image: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
    url("../assets/images/bottom.jpg");
    background-size: cover;
    background-position: center center;
}
</style>